import React from "react";
import { Box } from "@chakra-ui/react";
import { RadialGradient } from "ui/radial-gradient";

export function BackgroundGradient() {
  return (
    <Box pos="absolute" inset={0}>
      <RadialGradient
        variant="mint"
        inset={{ base: "-2%", lg: "-6%" }}
        w="65%"
        h="80%"
        bottom="auto"
        transform="rotate(6.126deg)"
        opacity={{ base: 1, md: 0.8 }}
      />
      <RadialGradient
        variant="lightspeed"
        bottom={{ base: "-6%", lg: "-12%" }}
        left={{ base: "2%", lg: "10%" }}
        w="60%"
        h="80%"
        opacity={{ base: 1, md: 0.8 }}
      />
      <RadialGradient
        variant="cyan"
        right={{ base: 0, lg: "-2%" }}
        top={{ base: "18%", lg: "12%" }}
        w="65%"
        h={{ base: "80%", lg: "96%" }}
        transform="rotate(-6.72deg)"
        opacity={{ base: 1, md: 0.8 }}
      />
    </Box>
  );
}
